import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  banner: {
    backgroundColor: theme.colorPalette.beige_60,
    color: theme.colorPalette.green_90,
    padding: theme.spacing(2, 8),
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2)
  },
  warningBanner: {
    backgroundColor: theme.colorPalette.orange_50,
    color: theme.colorPalette.white_10,
    padding: theme.spacing(2, 8),
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2)
  },
  bannerText: {
    fontSize: '14px',
    lineHeight: '20px',
    fontWeight: 400
  },
  bannerTitle: {
    fontWeight: 600
  }
}));

export default useStyles;
